import { NotificationRegistry } from '@neos/core'
import BackgroundServerMethodStartingArgs from '@src/dataObjects/BackgroundServerMethodStartingArgs'
import LogMessageJobTriggeredArguments from '@src/dataObjects/LogMessageJobTriggeredArguments'
import ScheduledTaskExecutionChangedArgs from '@src/dataObjects/ScheduledTaskExecutionChangedArgs'

/**
 * Represents Notifications.
 */
export default class Notifications extends NotificationRegistry {
  /**
   * Gets or sets BackgroundServerMethodStarting.
   */
  backgroundServerMethodStarting = this.create<BackgroundServerMethodStartingArgs, void>('BackgroundServerMethodStarting')

  /**
   * Gets or sets LogMessageJobTriggered.
   */
  logMessageJobTriggered = this.create<LogMessageJobTriggeredArguments, void>('LogMessageJobTriggered')

  /**
   * Gets or sets ScheduledTaskExecutionChanged.
   */
  scheduledTaskExecutionChanged = this.create<ScheduledTaskExecutionChangedArgs, void>('ScheduledTaskExecutionChanged')
}